import { render, staticRenderFns } from "./DepartConfigDialog.vue?vue&type=template&id=2e1b7a10&scoped=true"
import script from "./DepartConfigDialog.vue?vue&type=script&lang=js"
export * from "./DepartConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./DepartConfigDialog.vue?vue&type=style&index=0&id=2e1b7a10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1b7a10",
  null
  
)

export default component.exports